/**
 * Org Invoice Requests Slice Constants
 *
 * Type-safe operation names for loading states and error tracking.
 * Using constants prevents typos and enables IDE autocomplete.
 */

export const ORG_INVOICE_REQUESTS_OPERATIONS = {
  FETCH_ORG: 'fetchOrgInvoiceRequests',
  SUBMIT: 'submitInvoiceRequest',
  CANCEL: 'cancelInvoiceRequest',
} as const;
